<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18ypcaM/tc-custom/9781504073837.jpg?1705205289456" alt="This image is the cover for the book Polls Apart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Polls Apart
      </h1>
      <p class="bookDescription body article font2">
        <b>Power, ambition, and love collide in this story of a high-profile couple tested by scandal: “Addictive . . . a smart, razor-sharp novel.” —<i>Daily Record</i></b><br/>  <br/> Richard Williams has risen in the ranks of British politics and is a stone’s throw from becoming prime minister. But his wife’s latest scandal puts everything he’s worked for in jeopardy—and his adviser is putting pressure on him to cut her loose.<br/>  <br/> Anna Lloyd, a famous actress, may have embarrassed her husband one too many times, but she sees an opportunity to come clean about her past—including a secret more shocking than any already revealed in the media. The only problem is she might lose her marriage and her beloved sister in the process.<br/>  <br/> Marie Simpson is a tabloid reporter who’s been tasked with taking Richard and Anna down. Her work will set in motion a personal and political drama that fascinates the public. But will her doubts about destroying lives interfere with the ultimate scoop?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clare Johnston
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b72ac8a